module.exports = __webpack_public_path__ + "img/headshot-srodriguez.b16ba407.png";